export default __webpack_public_path__ + "static/media/PostCode.8aee1904.svg";